<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<b-tabs v-model="selectedTabIndex">
			<b-tab title="Rezervacija" class="pt-2" card>
				<CRow>
					<CCol>
						<b-card>
							<div slot="header">
								<b>Termin najema</b> (Št. dni: {{ reservationLengthInDays }})
							</div>
							<CRow>
								<CCol v-if="editingDisabled">
									<CInput
										:disabled = editingDisabled
										label="Začetek"
										:value="getDateInputValue(replacementVehicleReservation.startsOn)"/>
								</CCol>
								<CCol v-else>
									<v-date-picker
										locale="sl-SI"
										v-model="replacementVehicleReservation.startsOn"
										@input="startsOnInput"
										:model-config=" {
											type: 'string',
										}"
										:min-date="startsOnLimit"
										:max-date="endsOnLimit"
										:mode="datePickerMode"
										is24hr
										:timezone="datePickerTimezone">
										<template v-slot="{ inputValue, inputEvents }">
											<CInput
												label="Začetek"
												:value="inputValue"
												v-on="inputEvents"/>
										</template>
									</v-date-picker>
								</CCol>
								<CCol v-if="editingDisabled">
									<CInput
										:disabled = editingDisabled
										label="Konec"
										:value="getDateInputValue(replacementVehicleReservation.endsOn)"/>
								</CCol>
								<CCol v-else>
									<v-date-picker
										locale="sl-SI"
										v-model="replacementVehicleReservation.endsOn"
										:model-config=" {
											type: 'string',
										}"
										:mode="datePickerMode"
										is24hr
										:timezone="datePickerTimezone"
										:min-date="replacementVehicleReservation.startsOn"
										:max-date="endsOnLimit">
										<template v-slot="{ inputValue, inputEvents }">
											<CInput
												label="Konec"
												:value="inputValue"
												v-on="inputEvents"/>
										</template>
									</v-date-picker>
								</CCol>
							</CRow>
						</b-card>
					</CCol>
				</CRow>
				<CRow class="mb-3" v-if="!spOrderPreselected">
					<CCol>
						<label>Delovni nalog</label>
						<v-select
							:disabled="editingDisabled"
							v-model="selectedSpOrder"
							label="sp_order_number"
							:options="spOrders_options"
							@input="spOrderSelect_change($event)"
							@search="spOrderSelect_search"
							placeholder="Izberi št. DN">
							<template slot="no-options">Ni najdenih DN</template>
						</v-select>
					</CCol>
					<CCol>
						<CRow>
							<CCol>
								<label>Stranka</label>
								<v-select
									:disabled="editingDisabled"
									v-model="selectedClient"
									label="title"
									:options="clients_options"
									@input="clientSelect_change($event)"
									@search="clientSelect_search"
									placeholder="Izberi stranko"
									:taggable="true"
									ref="vSelectClient">
									<template slot="no-options">Stranka ne obstaja</template>
									<template slot="option" slot-scope="option">
										<div v-if="option.id">{{ option.title }}</div>
										<div v-else><b>Dodaj stranko {{option.first_name}}</b></div>
									</template>
									<template slot="selected-option" slot-scope="option">
										{{ option.title }}
									</template>
								</v-select>
							</CCol>
							<CCol sm="2" class="p-sm-0">
								<div class="clientEditButton" >
									<CLink :disabled="!selectedClient" title="Uredi stranko" href="#" @click.stop="click_editClient">
										<CIcon name="cil-pencil"/>
									</CLink>
								</div>
							</CCol>
						</CRow>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							label="Vozilo oddal"
							:disabled = editingDisabled
							v-model="replacementVehicleReservation.handedOverBy"/>
					</CCol>
					<CCol>
						<CInput
							label="Voznik"
							:disabled = editingDisabled
							v-model="replacementVehicleReservation.driver"/>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							label="Komentar"
							:disabled = editingDisabled
							v-model="replacementVehicleReservation.comment"/>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<CInput
							label="Opombe"
							:disabled = editingDisabled
							v-model="replacementVehicleReservation.notes"/>
					</CCol>
				</CRow>
			</b-tab>
			<b-tab title="Pogodba" class="pt-2" card>
				<CRow v-if="false">
					<CCol>
						<b-card>
							<div slot="header">
								<b>Veljavnost najemne pogodbe</b>
							</div>
							<CRow>
								<CCol v-if="editingDisabled">
									<CInput
										:disabled = editingDisabled
										label="Od"
										:value="getDateInputValue(replacementVehicleReservation.contractValidFrom)"/>
								</CCol>
								<CCol v-else>
									<v-date-picker
										locale="sl-SI"
										v-model="replacementVehicleReservation.contractValidFrom"
										:model-config=" {
											type: 'string',
										}"
										:mode="datePickerMode"
										is24hr
										:timezone="datePickerTimezone">
										<template v-slot="{ inputValue, inputEvents }">
											<CInput
												label="Od"
												:value="inputValue"
												v-on="inputEvents"/>
										</template>
									</v-date-picker>
								</CCol>
								<CCol v-if="editingDisabled">
									<CInput
									class="mt-2"
										:disabled = editingDisabled
										label="Do"
										:value="getDateInputValue(replacementVehicleReservation.contractValidTo)"/>
								</CCol>
								<CCol v-else>
									<v-date-picker
									class="mt-2"
										locale="sl-SI"
										v-model="replacementVehicleReservation.contractValidTo"
										:model-config=" {
											type: 'string',
										}"
										:mode="datePickerMode"
										is24hr
										:timezone="datePickerTimezone">
										<template v-slot="{ inputValue, inputEvents }">
											<CInput
												label="Do"
												:value="inputValue"
												v-on="inputEvents"/>
										</template>
									</v-date-picker>
								</CCol>
							</CRow>
						</b-card>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<b-card>
							<CRow>
								<CCol>
									<CInput
										label="Št. vozniškega dovoljenja"
										:disabled = editingDisabled
										v-model="replacementVehicleReservation.drivingLicenceNumber"/>
								</CCol>
								<CCol>
									<CInput
										label="Odbitna franšiza"
										:disabled = editingDisabled
										v-model="replacementVehicleReservation.deductibleFranchise"/>
								</CCol>
							</CRow>
							<CRow>
								<CCol>
									<CInput
										:placeholder="replacementVehicleReservation.infoInitialFuelLevel ? 'Informativno stanje: ' + replacementVehicleReservation.infoInitialFuelLevel : ''"
										label="Stanje goriva pred izdajo vozila"
										:disabled = editingDisabled
										v-model="replacementVehicleReservation.initialFuelLevel"/>
								</CCol>
								<CCol>
									<CInput
										:placeholder="replacementVehicleReservation.infoInitialKmStatus ? 'Informativno stanje: ' + replacementVehicleReservation.infoInitialKmStatus : ''"
										label="Stanje začetnih km"
										:disabled = editingDisabled
										v-model="replacementVehicleReservation.initialKmStatus"/>
								</CCol>
							</CRow>
						</b-card>
					</CCol>
				</CRow>
				<CRow v-if="mode === mode_DETAILS3">
					<CCol>
						<b-card>
							<CRow>
								<CCol>
									<CInput
										label="Stanje goriva po vrnitvi vozila"
										:disabled = "replacementVehicleReservation.contractFinishedAt"
										v-model="replacementVehicleReservation.finalFuelLevel"/>
								</CCol>
								<CCol>
									<CInput
										label="Stanje končnih km"
										:disabled = "replacementVehicleReservation.contractFinishedAt"
										v-model="replacementVehicleReservation.finalKmStatus"/>
								</CCol>
							</CRow>
						</b-card>
					</CCol>
				</CRow>
			</b-tab>
		</b-tabs>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col>
						<b-row>
							<b-col cols="2">
								<b-button v-if="mode !== mode_CREATE1" :disabled="replacementVehicleReservation.contractPrintedAt != null || isLoading" :title="replacementVehicleReservation.contractPrintedAt ? 'Vozilo je že bilo izdano' : 'Izbriš rezervacijo'" variant="danger" @click="click_replacementVehicleReservationDelete(replacementVehicleReservation)">Izbriši</b-button>
							</b-col>
							<b-col>
								<custom-date-select v-if="mode !== mode_CREATE1 && replacementVehicleReservation.contractPrintedAt != null && replacementVehicleReservation.contractFinishedAt == null" :disabled="isLoading" ref="annualServiceDateFilter" @input="extend" default_label="Podaljšaj pogodbo" :minDate="minReservationExtensionDate"/>
							</b-col>
						</b-row>
					</b-col>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="!(mode === mode_DETAILS3 && replacementVehicleReservation.contractFinishedAt)" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="contractPrintDisabled" :title="contractPrintTitle" style="margin-right:5px;" variant="primary" @click="contractExport_click()">{{ contractPrintLabel }}</b-button>
						<b-button :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButtonLabel }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
		<sp-order-client-create-edit-modal ref="spOrderClientCreateEditModal" @emit_spOrderClientCreatedOrEdited="emit_spOrderClientCreatedOrEdited" @emit_spOrderClientModalCancel="emit_spOrderClientModalCancel"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
import { REPLACEMENT_VEHICLE_RESERVATION_CREATE, REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT, REPLACEMENT_VEHICLE_RESERVATION_DELETE, REPLACEMENT_VEHICLE_RESERVATION_EXTEND } from '../../store/actions/replacementVehicleReservations';
import { SP_ORDERS_SEARCH_BY_SP_ORDER_NUMBER } from '../../store/actions/spOrders';
import { SP_ORDER_CLIENTS_SEARCH, SP_ORDER_CLIENT_CREATE } from '../../store/actions/spOrderClients';
import { addDays, addHours, differenceInDays } from 'date-fns';
import { REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL, REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION } from '../../store/actions/replacementVehicles';
import _ from 'lodash';
import CustomDateSelect from '@/views/components/CustomDateSelect';

export default {
	name: 'replacement-vehicle-reservation-create-edit-modal',
	components: {
		'custom-date-select': CustomDateSelect,
	},
	props: {
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Create
			*/
			this.mode = modalInput.mode;
			this.initModal(modalInput.replacementVehicleReservation, modalInput.replacementVehicleVin, modalInput.issuedButNotFinishedReservation);
		},
		initModal: function (replacementVehicleReservation, replacementVehicleVin, issuedButNotFinishedReservation) {
			this.issuedButNotFinishedReservation = issuedButNotFinishedReservation;
			this.replacementVehicleReservation.replacementVehicleId = replacementVehicleReservation.replacementVehicleId;
			if (this.mode === this.mode_CREATE1 && replacementVehicleReservation.replacementVehicleId) {
				let titleSpOrderData = '';
				if (replacementVehicleReservation.spOrder) {
					this.spOrderPreselected = true;
					this.replacementVehicleReservation.spOrderId = replacementVehicleReservation.spOrder.id;
					this.replacementVehicleReservation.clientId = replacementVehicleReservation.spOrder.clientId;
					titleSpOrderData = ' (DN: ' + replacementVehicleReservation.spOrder.spOrderNumber + ')'
				}
				this.title = 'Dodajanje rezervacije za vozilo ' + replacementVehicleVin + titleSpOrderData;
				let today = new Date();
				today.setUTCHours(0, 0, 0, 0);
				this.replacementVehicleReservation.startsOn = replacementVehicleReservation.startsOn ?? today;
				// WITHTIME: this.replacementVehicleReservation.startsOn = addHours(today, 1).toISOString();
				// WITHTIME: today.setUTCHours(15, 0, 0, 0);
				this.replacementVehicleReservation.endsOn = replacementVehicleReservation.endsOn ?? addDays(this.replacementVehicleReservation.startsOn, 3).toISOString();
				this.replacementVehicleReservation.contractValidFrom = this.replacementVehicleReservation.startsOn;
				this.replacementVehicleReservation.contractValidTo = this.replacementVehicleReservation.endsOn;
			} else if (this.mode === this.mode_EDIT2 && replacementVehicleReservation.id) {
				this.title = 'Urejanje rezervacije ' + replacementVehicleReservation.id;
				this.initReplacementVehicleReservation(replacementVehicleReservation);
			} else if (this.mode === this.mode_DETAILS3) {
				this.title = 'Rezervacija ' + replacementVehicleReservation.id;
				this.initReplacementVehicleReservation(replacementVehicleReservation);
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
			}
			if (!this.replacementVehicleReservation.contractPrintedAt) {
				this.getLatestReplacementVehicleKmAndFuel();
				this.getReplacementVehicleBoundaries();
			}
			this.$refs.modal.show();
		},
		initReplacementVehicleReservation: function (replacementVehicleReservation) {
			this.replacementVehicleReservation.id = replacementVehicleReservation.id;
			this.replacementVehicleReservation.spOrderId = replacementVehicleReservation.sp_order_id;
			if (replacementVehicleReservation.sp_order) this.selectedSpOrder = replacementVehicleReservation.sp_order;
			if (replacementVehicleReservation.client) {
				this.replacementVehicleReservation.clientId = replacementVehicleReservation.client.id;
				this.selectedClient = replacementVehicleReservation.client;
				this.selectedClient.title = this.mixinGetClientFullName(replacementVehicleReservation.client);
			}
			this.replacementVehicleReservation.replacementVehicleId = replacementVehicleReservation.replacement_vehicle_id;
			// WITHTIME: this.replacementVehicleReservation.startsOn = this.$options.filters.viewDateTime(replacementVehicleReservation.starts_on); // PROBLEM WITH DATE MONTH DAY CONVERT 9.12 -> 12.9
			// WITHTIME: this.replacementVehicleReservation.endsOn = this.$options.filters.viewDateTime(replacementVehicleReservation.ends_on); // PROBLEM WITH DATE MONTH DAY CONVERT 9.12 -> 12.9
			this.replacementVehicleReservation.startsOn = replacementVehicleReservation.starts_on;
			this.replacementVehicleReservation.endsOn = replacementVehicleReservation.ends_on;
			this.replacementVehicleReservation.comment = replacementVehicleReservation.comment;
			this.replacementVehicleReservation.handedOverBy = replacementVehicleReservation.handed_over_by;
			this.replacementVehicleReservation.notes = replacementVehicleReservation.notes;
			this.replacementVehicleReservation.contractValidFrom = replacementVehicleReservation.contract_valid_from;
			this.replacementVehicleReservation.contractValidTo = replacementVehicleReservation.contract_valid_to;
			this.replacementVehicleReservation.drivingLicenceNumber = replacementVehicleReservation.driving_licence_number;
			this.replacementVehicleReservation.driver = replacementVehicleReservation.driver;
			this.replacementVehicleReservation.initialKmStatus = replacementVehicleReservation.initial_km_status;
			this.replacementVehicleReservation.finalKmStatus = replacementVehicleReservation.final_km_status;
			this.replacementVehicleReservation.initialFuelLevel = replacementVehicleReservation.initial_fuel_level;
			this.replacementVehicleReservation.finalFuelLevel = replacementVehicleReservation.final_fuel_level;
			this.replacementVehicleReservation.deductibleFranchise = replacementVehicleReservation.deductible_franchise;
			this.replacementVehicleReservation.contractPrintedBy = replacementVehicleReservation.contract_printed_by;
			this.replacementVehicleReservation.contractPrintedAt = replacementVehicleReservation.contract_printed_at;
			this.replacementVehicleReservation.contractFinishedBy = replacementVehicleReservation.contract_finished_by;
			this.replacementVehicleReservation.contractFinishedAt = replacementVehicleReservation.contract_finished_at;
			if (this.replacementVehicleReservation.contractPrintedAt) {
				this.mode = this.mode_DETAILS3;
			}
		},
		onOkModal: function () {
			if (this.mode == this.mode_DETAILS3 && this.replacementVehicleReservation.contractFinishedAt) {
				this.$refs.modal.hide();
			}
			else this.saveReplacementVehicleReservation();
		},
		saveReplacementVehicleReservation: function (doExport) {
			let finishContract = false;
			if (this.mode === this.mode_DETAILS3 ) {
				if (!this.replacementVehicleReservation.finalKmStatus || !this.replacementVehicleReservation.finalFuelLevel) {
					this.showAlert('Za zaključitev pogodbe je končno stanje kilometrov in goriva obvezno', this.ALERT_TYPE_ERROR);
					return;
				}
				finishContract = true;
			}
			if (doExport) {
				let issueDataAlert = 'Za izdajo manjkajo parametri:';
				if (!this.replacementVehicleReservation.clientId) issueDataAlert += ' stranka,';
				if (!this.replacementVehicleReservation.drivingLicenceNumber) issueDataAlert += ' št. vozniškega dovoljenja,';
				if (!this.replacementVehicleReservation.deductibleFranchise) issueDataAlert += ' odbitna frašniza,';
				if (!this.replacementVehicleReservation.initialKmStatus && !this.replacementVehicleReservation.infoInitialKmStatus) issueDataAlert += ' stanje goriva pred izdajo vozila,';
				if (!this.replacementVehicleReservation.initialFuelLevel && !this.replacementVehicleReservation.infoInitialFuelLevel) issueDataAlert += ' stanje začetnih km,';
				if (issueDataAlert.slice(-1) === ',') {
					this.showAlert(issueDataAlert.slice(0, -1) + ".", this.ALERT_TYPE_ERROR);
					return;
				}
			}
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_CREATE, { replacementVehicleReservation: this.replacementVehicleReservation, finishContract })
				.then((responseData) => {
					this.stopProgress();
					if (responseData.message === 'unavailable') {
						this.showAlert('Vozilo je med temi datumi že rezervirano (Rezervacija #' + responseData.exsistingReplacementVehicleReservation.id + ')', this.ALERT_TYPE_ERROR);
						return;
					}
					if (doExport) {
						this.initReplacementVehicleReservation(responseData.replacementVehicleReservation);
						this.contractExport();
					} else {
						this.$emit('emit_replacementVehicleReservationCreatedOrEdited', responseData);
						this.$refs.modal.hide();
					}
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						if (this.mode === this.mode_CREATE1) {
							this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else if (this.mode === this.mode_EDIT2) {
							this.showAlert('Napaka pri urejanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
							this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						}
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
			this.mode = 0;
			this.spOrderPreselected = false;
			this.spOrders_options = [];
			this.selectedSpOrder = null;
			this.clients_options = [];
			this.selectedClient = null;
			this.selectedTabIndex = 0;
			this.resetReplacementVehicleReservationObject();
			this.issuedButNotFinishedReservation = null;
			this.startsOnLimit = null;
			this.endsOnLimit = null;
		},
		resetReplacementVehicleReservationObject: function () {
			this.replacementVehicleReservation.id = null;
			this.replacementVehicleReservation.replacementVehicleId = null;
			this.replacementVehicleReservation.spOrderId = null;
			this.replacementVehicleReservation.spOrderNumber = null;
			this.replacementVehicleReservation.clientId = null;
			this.replacementVehicleReservation.startsOn = null;
			this.replacementVehicleReservation.endsOn = null;
			this.replacementVehicleReservation.comment = null;
			this.replacementVehicleReservation.handedOverBy = null;
			this.replacementVehicleReservation.notes = null;
			this.replacementVehicleReservation.contractValidFrom = null;
			this.replacementVehicleReservation.contractValidTo = null;
			this.replacementVehicleReservation.drivingLicenceNumber = null;
			this.replacementVehicleReservation.driver = null;
			this.replacementVehicleReservation.initialKmStatus = null;
			this.replacementVehicleReservation.finalKmStatus = null;
			this.replacementVehicleReservation.initialFuelLevel = null;
			this.replacementVehicleReservation.finalFuelLevel = null;
			this.replacementVehicleReservation.deductibleFranchise = '2%';
			this.replacementVehicleReservation.contractPrintedBy = null;
			this.replacementVehicleReservation.contractPrintedAt = null;
			this.replacementVehicleReservation.contractFinishedAt = null;
			this.replacementVehicleReservation.contractFinishedBy = null;
			this.replacementVehicleReservation.infoInitialKmStatus = null;
			this.replacementVehicleReservation.infoInitialFuelLevel = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		spOrderSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDERS_SEARCH_BY_SP_ORDER_NUMBER, search )
				.then((responseData) => {
					loading(false);
					context.spOrders_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju naročil ND! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju naročil ND! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		spOrderSelect_search: function (search, loading) {
			if (search && search !== '' && search.length >= 2) {
				this.spOrderSelect_load(loading, search, this);
			}
		},
		spOrderSelect_change: function (value) {
			if (value) {
				this.replacementVehicleReservation.spOrderId = value.id;
				if (value.client) {
					this.replacementVehicleReservation.clientId = value.client.id;
					this.selectedClient = value.client;
					this.selectedClient.title = this.mixinGetClientFullName(value.client);
				}
			} else {
				this.replacementVehicleReservation.spOrderId = null;
			}
		},
		clientSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDER_CLIENTS_SEARCH, search )
				.then((responseData) => {
					loading(false);
					context.clients_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju strank! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju strank! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		clientSelect_search: function (search, loading) {
			if (search && search !== '' && search.length >= 2) {
				this.clientSelect_load(loading, search, this);
			}
		},
		clientSelect_change: function (client) {
			if (client) {
				if (client.id) {
					this.replacementVehicleReservation.clientId = client.id;
				} else {
					let defaultClient = this.getDefaultClient();
					let inputValue = client.first_name ?? client.title;
					let spaceIndex = inputValue.indexOf(' ');
					if(spaceIndex > -1) {
						defaultClient.firstName = inputValue.substring(0, spaceIndex)
						defaultClient.lastName = inputValue.substring(spaceIndex+1);
					} else {
						defaultClient.firstName = inputValue;
					}
					this.startProgress();
					this.$store.dispatch(SP_ORDER_CLIENT_CREATE, { client: defaultClient })
						.then((responseData) => {
							this.replacementVehicleReservation.clientId = responseData.client.id;
							this.selectedClient = responseData.client;
							this.selectedClient.title = this.mixinGetClientFullName(responseData.client);
							this.stopProgress();
						})
						.catch(error => {
							this.stopProgress();
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri dodajanju stranke! Prosimo poizkusite kasneje (' + error.response.data.code + ').', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka pri dodajanju stranke! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				}
			} else {
				this.replacementVehicleReservation.clientId = null;
			}
		},
		getDefaultClient: function () {
			return {
				firstName: '',
				lastName: '',
				isCompany: false
			};
		},
		click_editClient: function () {
			let modalInput = {
				mode: 2,
				client: this.selectedClient
			}
			this.$refs.spOrderClientCreateEditModal.showModal(modalInput);
		},
		emit_spOrderClientCreatedOrEdited: function (data) {
			this.selectedClient = data.client;
			this.selectedClient.title = this.mixinGetClientFullName(data.client);
			this.clientSelect_change(data.client);
			const searchEl = this.$refs.vSelectClient.searchEl;
			if (searchEl) {
				searchEl.blur();
			}
			this.$emit('emit_replacementVehicleReservationCreatedOrEdited');
		},
		emit_spOrderClientModalCancel: function () {
			if (!this.selectedClient.id) {
				this.selectedClient = null;
			}
		},
		contractExport_click: function () {
			if (this.mode === this.mode_DETAILS3) {
				this.contractExport();
			} else {
				const doExport = true;
				this.saveReplacementVehicleReservation(doExport);
			}
		},
		contractExport: function () {
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_CONTRACT_EXPORT, { id: this.replacementVehicleReservation.id })
				.then((responseData) => {
					this.stopProgress();
					var newBlob = new Blob([responseData.data], {type: responseData.headers['content-type']});
					const data = window.URL.createObjectURL(newBlob);
					const newWindowForPdf = window.open(data); 
					if (newWindowForPdf) {
						newWindowForPdf.onload = () => {
							newWindowForPdf.focus();
							newWindowForPdf.print();
						}
					}
					if (this.mode === this.mode_CREATE1 || this.mode === this.mode_EDIT2) {
						this.replacementVehicleReservation.contractPrintedBy = new Date();
						this.replacementVehicleReservation.contractPrintedAt = this.profile.id;
						this.replacementVehicleReservation.initialKmStatus = responseData.headers['initial-km'];
						this.replacementVehicleReservation.initialFuelLevel = responseData.headers['initial-fuel'];
						this.mode = this.mode_DETAILS3;
						this.$emit('emit_replacementVehicleReservationCreatedOrEdited');
					}
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri izvozu pogodbe! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		click_replacementVehicleReservationDelete: function (data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati rezervacijo ' + data.id + '?', {
				title: 'Potrdite brisanje rezervacije nadomestnega vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.startProgress();
					this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_DELETE, { id: data.id })
						.then((responseData) => {
							this.stopProgress();
							this.$emit('emit_replacementVehicleReservationCreatedOrEdited');
							this.$refs.modal.hide();
						})
						.catch(error => {
							this.stopProgress();
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri brisanju rezervacije! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka pri brisanju rezervacije! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				}
			}).catch(err => {
				console.error(err);
			})
		},
		getLatestReplacementVehicleKmAndFuel: function () {
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL, this.replacementVehicleReservation.replacementVehicleId )
				.then((responseData) => {
					this.stopProgress();
					this.replacementVehicleReservation.infoInitialKmStatus = responseData.latestKmStatus;
					this.replacementVehicleReservation.infoInitialFuelLevel = responseData.latestFuelLevel;
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju informativnega stanja kilometrov in goriva! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('NNapaka pri pridobivanju informativnega stanja kilometrov in goriva! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		extend: function (newEndsOn) {
			this.startProgress();
			let extendTo = new Date(newEndsOn);
			extendTo.setUTCHours(0, 0, 0, 0);
			this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_EXTEND, { id: this.replacementVehicleReservation.id, endsOn: extendTo.toISOString() })
				.then((responseData) => {
					if (responseData.message === 'contractAlreadyFinished') this.showAlert('Pogodba je že zaključena.', this.ALERT_TYPE_ERROR);
					else if (responseData.message === 'unavailable') {
						this.showAlert('Nov datum se prekriva z rezervacijo #' + responseData.exsistingReplacementVehicleReservation.id + ' (' + this.$options.filters.viewDate(responseData.exsistingReplacementVehicleReservation.starts_on) + ' - ' + this.$options.filters.viewDate(responseData.exsistingReplacementVehicleReservation.ends_on) + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.$emit('emit_replacementVehicleReservationCreatedOrEdited');
						 this.replacementVehicleReservation.endsOn = responseData.replacementVehicleReservation.ends_on;
						 this.showAlert('Pogodba uspešno podaljšana do ' + this.$options.filters.viewDate(responseData.replacementVehicleReservation.ends_on), this.ALERT_TYPE_SUCCESS, 5);
					}
					this.stopProgress();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri podaljšanju pogodbe! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		getReplacementVehicleBoundaries: function () {
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION, { id: this.replacementVehicleReservation.replacementVehicleId, startsOn: this.replacementVehicleReservation.startsOn })
				.then((responseData) => {
					this.stopProgress();
					const currendDate = new Date();
					this.startsOnLimit = currendDate;
					if (responseData.previousReplacementVehicleReservation && new Date(responseData.previousReplacementVehicleReservation.ends_on) > currendDate) {
						this.startsOnLimit = new Date(responseData.previousReplacementVehicleReservation.ends_on);
					}
					if (responseData.nextReplacementVehicleReservation) {
						this.endsOnLimit = new Date(responseData.nextReplacementVehicleReservation.starts_on);
					}
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju omejitev datumov! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka pri pridobivanju omejitev datumov! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		startsOnInput: function () {
			this.getReplacementVehicleBoundaries();
		},
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_CREATE1: 1,
			mode_EDIT2: 2,
			mode_DETAILS3: 3,
			mode: 0,
			replacementVehicleReservation: {
				id: null,
				replacementVehicleId: null,
				spOrderId: null,
				spOrderNumber: null,
				clientId: null,
				startsOn: null,
				endsOn: null,
				comment: null,
				handedOverBy: null,
				notes: null,
				contractValidFrom: null,
				contractValidTo: null,
				drivingLicenceNumber: null,
				driver: null,
				initialKmStatus: null,
				finalKmStatus: null,
				initialFuelLevel: null,
				finalFuelLevel: null,
				deductibleFranchise: '2%',
				contractPrintedBy: null,
				contractPrintedAt: null,
				infoInitialKmStatus: null,
				infoInitialFuelLevel: null,
			},
			spOrderPreselected: false,
			spOrders_options: [],
			selectedSpOrder: null,
			clients_options: [],
			selectedClient: null,
			selectedTabIndex: 0,
			issuedButNotFinishedReservation: null,
			startsOnLimit: null,
			endsOnLimit: null,
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			return 'lg';
		},
		editingDisabled () {
			if (this.mode === this.mode_DETAILS3) {
				return true;
			}
			return false;
		},
		datePickerMode () {
			// WITHTIME: return 'dateTime';
			return 'date';
		},
		datePickerTimezone () {
			// WITHTIME: return 'Europe/Amsterdam';
			return 'utc';
		},
		reservationLengthInDays () {
			let startDate = this.replacementVehicleReservation.startsOn;
			let endDate = this.replacementVehicleReservation.endsOn;
			if (typeof startDate === 'string') startDate = new Date(startDate);
			if (typeof endDate === 'string') endDate = new Date(endDate);
			return Math.abs(differenceInDays(startDate, endDate)) + 1;
		},
		profile() {
			return this.$store.getters.getProfile
		},
		okButtonLabel() {
			if (this.mode === this.mode_CREATE1 || this.mode === this.mode_EDIT2) {
				return 'Shrani';
			} else if (this.mode === this.mode_DETAILS3 && this.replacementVehicleReservation.contractFinishedAt) {
				return 'Zapri';
			} else if (this.mode === this.mode_DETAILS3) {
				return 'Zaključi pogodbo';
			} else {
				return 'Neznan način';
			}
		},
		contractPrintLabel() {
			if (this.mode === this.mode_CREATE1 || this.mode === this.mode_EDIT2) {
				return 'Izdaj';
			} else if (this.mode === this.mode_DETAILS3) {
				return 'Natisni pogodbo';
			} else {
				return 'Neznan način';
			}
		},
		contractPrintTitle() {
			if (this.mode === this.mode_CREATE1 || this.mode === this.mode_EDIT2) {
				if (this.issuedButNotFinishedReservation) {
					return 'Rezervacija #' + this.issuedButNotFinishedReservation.id + ' še ni zaključena.';
				}
				return 'Izdaj';
			} else if (this.mode === this.mode_DETAILS3) {
				return 'Natisni pogodbo';
			} else {
				return 'Neznan način';
			}
		},
		contractPrintDisabled() {
			if (this.isLoading || ((this.mode === this.mode_CREATE1 || this.mode === this.mode_EDIT2) && this.issuedButNotFinishedReservation)) return true;
			return false;
		},
		minReservationExtensionDate() {
			return this.replacementVehicleReservation.endsOn ? addDays(new Date(this.replacementVehicleReservation.endsOn), 1).toISOString() : null;
		}
	},
	created () {
	}
		
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
</style>